<template>
  <path
    d="M11 15.0002H13V13.0002H11V15.0002ZM19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM14 9.00018H11V11.0002H13C14.1 11.0002 15 11.9002 15 13.0002V15.0002C15 16.1102 14.1 17.0002 13 17.0002H11C9.9 17.0002 9 16.1102 9 15.0002V9.00018C9 7.90018 9.9 7.00018 11 7.00018H14C14.55 7.00018 15 7.45018 15 8.00018C15 8.55018 14.55 9.00018 14 9.00018Z"
  />
</template>
